<template>
  <div class="">
    <nuxt-child></nuxt-child>
  </div>
</template>
<script>
export default {
  created() {
    if (process.client) {
      this.$hive.initHive();
      this.$hive.send('010012002');
    }
  },
  layout(ctx) {
    if (ctx.route.name.includes('ssrmobile')) {
      return 'ssrmobile';
    }
    if (ctx.route.name.includes('games-ad')) {
      return 'ad';
    }
  }
};
</script>
